import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Alert } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Lead } from '../../../models/Lead';
import { getLeadById } from '../../../services/leadService';
import { LeadDetailsComponent } from '../lead-details/lead-details-component';

export const LeadDetailsPage: React.FC = () => {
    const { leadId } = useParams<{ leadId: string }>();
    const navigate = useNavigate();
    const [lead, setLead] = useState<Lead | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchLead = async () => {
            if (!leadId) {
                setError('No lead ID provided');
                setLoading(false);
                return;
            }

            try {
                const fetchedLead = await getLeadById(leadId);
                if (!fetchedLead) {
                    setError('Lead not found');
                } else {
                    setLead(fetchedLead);
                }
            } catch (err) {
                console.error('Error fetching lead:', err);
                setError('Failed to load lead details');
            } finally {
                setLoading(false);
            }
        };

        fetchLead();
    }, [leadId]);

    const handleLeadUpdate = (updatedLead: Lead) => {
        setLead(updatedLead);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error || !lead) {
        return (
            <Box sx={{ p: 3 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate('/leads')}
                    sx={{ mb: 2 }}
                >
                    Back to Leads
                </Button>
                <Alert severity="error">{error || 'Lead not found'}</Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/leads')}
                sx={{ mb: 2 }}
            >
                Back to Leads
            </Button>
            <LeadDetailsComponent lead={lead} onLeadUpdate={handleLeadUpdate} />
        </Box>
    );
}; 